export default class SimpleBIConfig {

    //static KALOPSIA_URL_DEF = "https://cartos.kalopsia.pro:8443";
    static KALOPSIA_URL_DEF = "https://simplebi.cartofisserie.ro";
    static KALOPSIA_API_URL_DEF = "https://cartofisserie.kalopsia.pro";
    
    //Base & API
    static get BASE_URL() { return this.KALOPSIA_URL_DEF };
    static get BASE_API_URL() { return this.KALOPSIA_API_URL_DEF };
    //Change this when in production
    static get SIMPLEBI_URL() {return 'https://simplebi.cartofisserie.ro'};
    static get MAIN_URL() {return this.BASE_URL +'/Main/'};
    static get API_URL() {return this.KALOPSIA_API_URL_DEF + '/api/1.0/'};
}
